import axios from 'axios'
import store from '../store/store'
import router from '../router'
import { getToken, removeToken, removeRefreshToken } from './auth'
import { config, whiteList } from '@/config/index'
// import { refreshToken } from '../store/modules/user'
// 创建axios实例
const service = axios.create({
  baseURL: config.api,
  // baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1200000,
  withCredentials: false
})

// request拦截器
service.interceptors.request.use(config => {
  if (getToken()) {
    config.headers['X-auth-token'] =  getToken()
  }
  return config;
}, error => {
  return Promise.reject(error)
})

// response拦截器
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
// 作用：当请求过期，需要先刷新token后重新请求
let requests = []
service.interceptors.response.use(response => {
  const res = response.data
  if (res.status_code === 401) {
    // 用户未登录或登录过期
    const config = response.config
    if (!isRefreshing) {
      isRefreshing = true
      return new Promise((resolve, reject) => {
        store.dispatch('RefreshToken').then(res => {
          if(res.status_code === 200){
            // 已经刷新了token，将所有队列中的请求进行重试
            resolve(service(config))
            requests.reverse().forEach(cb => cb());
            requests = [];
          }else{
            removeToken();
            removeRefreshToken();
            store.commit('SET_AUTH', false);
            store.commit('SET_USER', {
              name: null,
              avatar: null,
              email: null,
              username: null,
              user_number: null
            })
            resolve(res);
          }
        }).catch((err) => {
          removeToken();
          removeRefreshToken();
          store.commit('SET_AUTH', false);
          store.commit('SET_USER', {
            name: null,
            avatar: null,
            email: null,
            username: null,
            user_number: null
          })
          reject(err)
        }).finally(() => {
          isRefreshing = false;
        })
      })
    } else {
      // 正在刷新token，将返回一个未执行resolve的promise
      return new Promise((resolve) => {
        // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        requests.push(() => {
          resolve(service(config))
        })
      })
    }
  }else if(res.status_code === 4011 || res.status_code === 4018){
    // 更新用户token失败
    removeToken();
    removeRefreshToken();
    store.commit('SET_AUTH', false);
    store.commit('SET_USER', {
      name: null,
      avatar: null,
      email: null,
      username: null,
      user_number: null
    })
    
    // 跳转到首页
    // router.push({ name: 'index' })

    // 跳转到登录页
    const routeUrl = router.resolve({
      name: "login_terminal",
    });
    window.location.href =
        `${config.loginUrl}` +
        encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
  }
  return res
}, err => {
  console.log('进入了response拦截器中，请注意是什么样的操作进来的')
  console.log(err.response)
  // 如果不在白名单里面&&token被删除了，则跳转
  if(whiteList.indexOf(router.history.current.name) < 0 && !getToken()){
    // removeToken();
    router.push({ name: 'index' })
    return false
  }
  return err.response.data;
})

export default service